import { Icon } from '@chakra-ui/react';

// 自行命名 Icon 名稱，如 MenuIcon
const LoadingIcon = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path fill='url(#myGradient)' d="M24 12C24 5.3728 18.6278 0 12 0C5.3728 0 0 5.3728 0 12H2.61286C2.61286 6.81604 6.81539 2.61286 12 2.61286C17.1846 2.61286 21.3871 6.81539 21.3871 12H24Z" >
        <animateTransform attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="0.6s"
          repeatCount="indefinite" />
      </path>
      <defs>
        <linearGradient id="myGradient"
          x1="0%" y1="0%"
          x2="0%" y2="100%"
          spreadMethod="pad">
          <stop offset="0%" stopColor="#D9D9D9" stopOpacity="1" />
          <stop offset="100%" stopColor="#000" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon >
  )
}

export default LoadingIcon

